import { useChartContext, estimateStringWidth } from '@shopify/polaris-viz-core';

function useGetLongestLabelFromData(tooltipData = []) {
  const {
    characterWidths
  } = useChartContext();
  const sizes = [];

  if (tooltipData.length === 0) {
    return {
      keyWidth: 0,
      valueWidth: 0
    };
  }

  tooltipData.forEach(({
    data
  }) => {
    if (!data.length) {
      sizes.push({
        width: 0,
        keyWidth: 0,
        valueWidth: 0
      });
    } else {
      data.forEach(({
        key,
        value
      }) => {
        const keyWidth = estimateStringWidth(key, characterWidths);
        const valueWidth = estimateStringWidth(value, characterWidths);
        sizes.push({
          width: keyWidth + valueWidth,
          keyWidth,
          valueWidth
        });
      });
    }
  });
  const {
    keyWidth,
    valueWidth
  } = sizes.reduce((prev, cur) => {
    if (prev.width < cur.width) {
      return cur;
    }

    return prev;
  }, sizes[0]);
  return {
    keyWidth,
    valueWidth
  };
}

export { useGetLongestLabelFromData };
